import { ObjectValues } from '@app/types';
import { DEFAULT_LOCALE as NEXT_I18N_DEFAULT_LOCALE } from '@redbubble/next-i18n';

export const EXPERIENCE = {
  SRP: 'srp',
  ARTIST_SHOP: 'artist-shop',
  ARTISTS_OWN_SHOP: 'artists-own-shop',
} as const;

export type ExperienceType = ObjectValues<typeof EXPERIENCE>;

export const ALL_DEPARTMENTS = 'all-departments';

export const ARTIST_SHOP_SORT_ORDER = {
  RECENT: 'recent',
  TOP_SELLING: 'top selling',
} as const;

export const ARTIST_PAGES_BASE_PATH = '/people';
export const ARTIST_SHOP_URL_SEGMENT = 'shop';
export const ARTIST_EXPLORE_URL_SEGMENT = 'explore';
export const ARTIST_SHOP_PER_PAGE_DEFAULT = 100;

// paths
export const SHOP_PAGE_BASE_PATH = '/shop';

// previews
export const PRODUCT_CLOSE_PREVIEW = 'product_close';
export const ALTERNATE_PRODUCT_CLOSE_PREVIEW = 'alternate_product_close';

export const DEFAULT_SEARCH_RESULT_PREVIEW = PRODUCT_CLOSE_PREVIEW;
export const ALTERNATE_SEARCH_RESULT_PREVIEW = ALTERNATE_PRODUCT_CLOSE_PREVIEW;

//misc
export const SRP_PAGE_KEYWORD_DELIMITER = '+';

export const DEFAULT_EXPERIENCE = EXPERIENCE.SRP;
export const DEFAULT_LOCALE = NEXT_I18N_DEFAULT_LOCALE;
